export default __webpack_public_path__ + "aca75c4f656d0b3fda798540fed20141.png";